import React from 'react';

interface UpArrowIconProps {
  className?: string;
  title?: string;
}

const UpArrowIcon: React.FC<UpArrowIconProps> = ({ className = "w-3 h-3", title }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {title && <title>{title}</title>}
      <path
        d="M6 2L10 8H2L6 2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default UpArrowIcon;
